import * as ACTION_TYPES from '../types';

let initialState = {
  rolePages: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_ROLE_PAGES_REQUEST:
      return { ...state, loading:true };
    case ACTION_TYPES.GET_ROLE_PAGES_SUCCESS:
      return { ...state, rolePages: action.data, loading: false };
    case ACTION_TYPES.GET_ROLE_PAGES_FAILED:
      return { ...state, loading: false };
    case ACTION_TYPES.RESET_ROLE_PAGES:
      return { ...state, rolePages: [] };
    default:
      return state;
  }
};
